<template>
  <div class="renge-charts">
    <!-- 人格特质与领导力评价 -->
    <div class="canvas-box" ref="myRengeChart"></div>
  </div>
</template>
<script>
import { renge } from "../echarts/config";
// import html2Canvas from "html2canvas"; //下载并导入包
export default {
  props: ["model"],
  data() {
    return {
      renge: renge,
      image1: "",
    };
  },
  //状态钩子
  mounted() {
    if (this.model) {
      this.renderMap();
    }
  },
  watch: {
    model(val) {
      if (val) {
        this.renderMap();
      }
    },
  },
  methods: {
    renderMap() {
      if (this.model) {
        this.renge.map((item) => {
          let hasItems = this.model.personalityValues.filter(
            (pv) => pv.key == item.key
          );

          if (hasItems.length > 0) {
            item.value = hasItems[0].value;
          }
        });
      }
      let keys = this.renge.map((item) => {
        return item.key + item.title;
      });
      let values = this.renge.map((item) => {
        return item.value;
      });

      var formatterFun = function(params) {
        var newParamsName = ""; // 最终拼接成的字符串
        var paramsNameNumber = params.length; // 实际标签的个数
        var provideNumber = 1; // 每行能显示的字的个数
        var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
        /**
         * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
         */
        // 条件等同于rowNumber>1
        if (paramsNameNumber > provideNumber) {
          /** 循环每一行,p表示行 */
          for (var p = 0; p < rowNumber; p++) {
            var tempStr = ""; // 表示每一次截取的字符串
            var start = p * provideNumber; // 开始截取的位置
            var end = start + provideNumber; // 结束截取的位置
            // 此处特殊处理最后一行的索引值
            if (p == rowNumber - 1) {
              // 最后一次不换行
              tempStr = params.substring(start, paramsNameNumber);
            } else {
              // 每一次拼接字符串并换行
              tempStr = params.substring(start, end) + "\n";
            }
            newParamsName += tempStr; // 最终拼成的字符串
          }
        } else {
          // 将旧标签的值赋给新标签
          newParamsName = params;
        }
        //将最终的字符串返回
        return newParamsName;
      };

      let myRengeChart = (window.cc = this.$echarts.init(
        this.$refs["myRengeChart"]
      ));

      let option = {
        ackgroundColor: "#fff",
        title: [{ text: "人格特质部分", x: "30%", y: 0 }],
        xAxis: {
          type: "category",
          data: keys,
          axisLabel: {
            formatter: formatterFun,
          },
        },
        yAxis: {
          min: 0,
          max: 10,
          interval: 2,
          type: "value",
        },
        series: [
          {
            name: "得分",
            type: "line",
            data: values,
            color: "#000080",
          },
        ],
      };
      myRengeChart.setOption(option);

      let that = this;
      // 延时获取图片，因为有动画效果，立即获取回导致获取的照片显示不全
      setTimeout(function() {
        that.getBaseImage(myRengeChart);
      }, 1000);
    },
    getBaseImage(chart) {
      this.image1 = chart.getDataURL({
        pixelRatio: 2,
        backgroundColor: "#fff",
      });

      // // 向父组件传图片base64格式
      // this.$parent.$parent.$parent.$parent.$parent.setImageBase(this.image1);
      this.$emit("image1", this.image1);
    },
  },
};
</script>

<style lang="scss" scoped>
.renge-charts {
  position: relative;
  .renge-name {
    font-weight: bold;
    text-align: center;
  }
  .canvas-box {
    width: 300px;
    height: 300px;
    margin: 1px auto 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/echarts/renge.vue